<template>
  <v-row justify="center">
    <v-dialog
      content-class="rounded-card"
      v-model="dialog"
      width="900"
      >
      <template v-slot:activator="{ on }">
        <slot name="activator" v-bind:on="on"></slot>
      </template>
      <v-card outlined class="rounded-card">
        <v-toolbar dense flat>
          <v-toolbar-title class="headline font-weight-bold">
            <v-icon class="icon">mdi-cart</v-icon> Carrinho
          </v-toolbar-title>
          <v-spacer></v-spacer>
           <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-5">
          <px-carrinho-matriz-detalhes :produtos="produtos"
                                       @update="emitUpdate"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import CarrinhoMatrizDetalhes from './CarrinhoMatrizDetalhes.vue';

export default {
  props: {
    produtos: Array,
  },
  data() {
    return {
      dialog: null,
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    PxCarrinhoMatrizDetalhes: CarrinhoMatrizDetalhes,
  },
};
</script>
<style scoped>
  .icon {
    font-size: 1.3rem;
  }
</style>
